'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

const CardBlock = forwardRef(function CardBlock({ asChild, className, ...rest }, ref) {
    const Component = asChild ? Slot : 'div';
    return (jsx(Component, { className: cl(`ds-card__block`, className), ref: ref, ...rest }));
});

export { CardBlock };
